export default __webpack_public_path__ + "static/Roboto-Black-ae0c1d409f7d45d81c29acebadd92ce8.woff2";